module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_sapporo-0f404b086e2b23521a969a7480b8da95.webp";